<template>

  <v-container v-if="bookingContext">

    <BookingHeader :bookingContext="bookingContext"/>


    <v-col cols="12" sm="12">
      <CarOptionChip class="ma-2" v-for="co in carOptions" :key="co.id" :option="co"
                     :hideText="co.hideText"></CarOptionChip>
    </v-col>


    <form @submit.prevent="validateAndSubmit" style="margin:2rem 1rem;">

      <!-- Title -->
      <h1 class="title is-4 has-text-left">Extras</h1>

      <!-- Additional Drivers -->
      <v-row class="ma-0" v-for="product in products" :key="product.id">
        <v-col  sm="6">
          <p>
            <b>{{product.name}}</b>
            {{ product.prix | currency }} {{product.type|optionType}}
          </p>
        </v-col>
        <v-col  sm="2">
          <v-text-field v-model="product.number" :label="$t('booking.options.number')" type="number"
                        v-on:change="checkMin(product)"/>
        </v-col>
        <v-col  sm="2"></v-col>
        <v-col  sm="2">
          <v-alert type="success">{{ getTotalProduct(product) | currency }} </v-alert>
        </v-col>
      </v-row>
      <v-row  class="ma-0" justify="end">
        <v-col  sm="4" >Total</v-col>
        <v-col  sm="2"  >
          <v-alert type="success">{{ total | currency }} </v-alert>
        </v-col>
      </v-row>


      <!-- error -->
      <AppAlert v-if="error" :alert="error"/>

      <!-- submit button -->
      <v-btn depressed color="primary" type="submit">
        <v-icon class="mr-2">mdi-arrow-right-circle</v-icon>&nbsp;&nbsp;{{$t('booking.process.next')}}
      </v-btn>

    </form>

  </v-container>

</template>

<script>
  import { CarOptionChip, BookingHeader } from '../components';
  import { CarOption, Options, BookingSteps } from "../models";
  import { AvailabilityCar } from "@/shared/models";
  import { BookingService } from "../services";
  import { LocationsApi } from '../../../shared/services/api'

  export default {
    name: 'BookingOptionsStep',
    props: {
      bookingContext: null
    },
    data () {
      return {
        products: [],
        carOptions: [
          new CarOption({
            id: 'car-category',
            color: 'blue',
            icon: 'mdi-car-info',
            text: this.bookingContext.availabilityCar.category
          }),
          new CarOption({
            id: 'car-type',
            color: 'blue',
            icon: 'mdi-car-cog',
            text: this.$options.filters.carType(this.bookingContext.availabilityCar.type)
          }),
          new CarOption({
            id: 'nbr-place',
            color: 'green',
            icon: 'mdi-car-seat',
            text: this.bookingContext.availabilityCar.nbrPlace
          }),
          new CarOption({
            id: 'agency',
            color: 'purple',
            icon: 'mdi-office-building',
            text: this.bookingContext.availabilityCar.agency.name + ' (' + this.bookingContext.availabilityCar.agency.address + ')'
          }),
          new CarOption({
            id: 'tenant',
            color: 'blue',
            icon: 'mdi-office-building',
            text: this.bookingContext.availabilityCar.tenantName
          })
        ],
        error: null
      }
    },
    methods: {
      checkMin (product) {
        return parseInt(product.number) <  product.minQuantity ? product.number = product.minQuantity : product.number ;
      },
      getTotalProduct (product) {
        switch (product.type) {
          case 'LOCATION' :
            return product.total = product.number * product.prix;
          case 'DAY':
            return product.total = this.bookingContext.availabilityCar.duration * product.number * product.prix;
        }
      },
      validateAndSubmit () {
        AvailabilityCar.setOptions(this.bookingContext.availabilityCar, this.products);
        this.$store.commit('booking/setContext', this.bookingContext);

        this.error = null;
        try {
          BookingService.checkBookingError(this.bookingContext, BookingSteps.OPTIONS);
          this.$emit('nextStep', this.bookingContext);
        } catch (error) {
          this.error = error;
        }
      },
    },
    computed :{
      total  : function () {
        let total =0;
        this.products.forEach(product=>{total+=this.getTotalProduct (product)})
        return total;
      }
    },
    created () {
      console.log("created Option step");
      LocationsApi.getOptionsProducts(this.bookingContext.availabilityCar.tenantName)
        .then(products => {
          if (!products || products.length == 0) {
            this.$emit('nextStep', this.bookingContext);
          }
          products.forEach(product => {
            product.number = product.minQuantity;
          })
          this.products = products;

        }).catch(err => {
      })

    },
    components: { BookingHeader, CarOptionChip }
  }
</script>

<style scoped>
</style>
